import React from "react";
import { DocumentCategoryCard } from "./DocumentCategoryCard";

type Props = {
  documentData: any;
  isXsOrSm: boolean;
  partnerStartedJourney: boolean;
  hideAddButton?: boolean;
  hideUploadButton?: boolean;
  hideAccountAggregator?: boolean;
  uploadDocumentLoader: any[];
  digiLockerLoaderId: any[];
  viewDocumentLoader: any[];
  uploadedVia: any;
  onShowAddMoreDocument: (categoryId: number) => void;
  onUploadDocument: (docId: any, item: any) => void;
  onViewDocument: (item: any) => void;
  onOpenAccountAggregatorModal: () => void;
  onCreateFIData?: (item: any) => void;
  onGetFIData?: (item: any) => void;
  showFIButtons?: boolean;
  showGetFIButton?: boolean;
};

export function DocumentCategoriesList({
  documentData,
  isXsOrSm,
  partnerStartedJourney,
  hideAddButton = false,
  hideUploadButton = false,
  hideAccountAggregator = false,
  uploadDocumentLoader,
  digiLockerLoaderId,
  viewDocumentLoader,
  uploadedVia,
  onShowAddMoreDocument,
  onUploadDocument,
  onViewDocument,
  onOpenAccountAggregatorModal,
  onCreateFIData,
  onGetFIData,
  showFIButtons,
  showGetFIButton,
}: Props) {
  if (!documentData || !Array.isArray(documentData)) return null;

  return (
    <>
      {documentData.map((elem: any) => (
        <DocumentCategoryCard
          key={elem?.id ?? elem?.name}
          elem={elem}
          isXsOrSm={isXsOrSm}
          partnerStartedJourney={partnerStartedJourney}
          hideAddButton={hideAddButton}
          hideUploadButton={hideUploadButton}
          hideAccountAggregator={hideAccountAggregator}
          uploadDocumentLoader={uploadDocumentLoader}
          digiLockerLoaderId={digiLockerLoaderId}
          viewDocumentLoader={viewDocumentLoader}
          uploadedVia={uploadedVia}
          onShowAddMoreDocument={onShowAddMoreDocument}
          onUploadDocument={onUploadDocument}
          onViewDocument={onViewDocument}
          onOpenAccountAggregatorModal={onOpenAccountAggregatorModal}
          onCreateFIData={onCreateFIData}
          onGetFIData={onGetFIData}
          showFIButtons={showFIButtons}
          showGetFIButton={showGetFIButton}
        />
      ))}
    </>
  );
}

